import {
  IOfferingSearchFilterEnum,
  IOfferingSearchInput,
  IOfferingSearchSortEnum,
} from '@r-client/data/graphql-types';

/**
 * Shared by the funded-ventures rail on /investment-opportunities and the full
 * /funded-ventures listing — both search the same slice of offerings, differing
 * only in page size and pagination.
 */
export const FUNDED_SEARCH_PARAMS: IOfferingSearchInput = {
  filter: IOfferingSearchFilterEnum.Funded,
  sort: IOfferingSearchSortEnum.MostFunded,
};
